import Matches from './matches';
import DateRangeRequired from './daterange-required';
import PasswordStrength from './password-strength';
import PhoneFormat from './phone-format';
import DropdownSelected from './dropdown-selected';
import MaxListLen from './max-list-len';

let Validators = {
    'matches': Matches,
    'date-range-required': DateRangeRequired,
    'password-strength': PasswordStrength,
    'phone-format': PhoneFormat,
    'dropdown-selected': DropdownSelected,
    'max-list-len': MaxListLen
};

export default Validators;
